import { prepareSpritesheetStyle } from "react-tech-tree";
import spriteInformation from "../data/spritesheet.json";

const spriteImage = `${process.env.PUBLIC_URL}/spritesheet.png`;
export const styleName = prepareSpritesheetStyle(
  spriteImage,
  spriteInformation
);

export interface IFrame {
  w: number;
  h: number;
  x: number;
  y: number;
}

interface IFrameInformation {
  frames: Record<string, { frame: IFrame }>;
}
const { frames }: IFrameInformation = spriteInformation;
export const allFrames = Object.keys(spriteInformation.frames);

const defaultName = "owl_white";
export function getSpriteFrames(name: string): IFrame[] {
  // a sprite typically has two frames. e.g: owl_white0 and owl_white1
  if (frames[`${name}0`] && frames[`${name}1`]) {
    return [frames[`${name}0`].frame, frames[`${name}1`].frame];
  }

  // if no sprite alternatives were found, just return the default one
  return getSpriteFrames(defaultName);
}

export function buildFrames(length: number, frameBase: string): IFrame[] {
  return Array(length)
    .fill(null)
    .map((_, i) => frames[`${frameBase}${i}`].frame);
}
